import PropTypes from 'prop-types';
import { memo, useState } from 'react';
import { BiExpand } from 'react-icons/bi';
import ImageGalleryModal from '../../../../ImageGallery/ImageGalleryModal';

const TourPhotos = ({ images }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
      {images.map((image, index) => {
        const url = image && image.url ? image.url : image;
        return (
          <button
            key={url}
            type="button"
            className="relative focus:outline-none"
            onClick={() => setSelectedImageIndex(index)}
          >
            <img src={url} alt="" className="w-full h-40 object-cover rounded" />
            <span className="absolute top-0 left-0 m-2 bg-black bg-opacity-70 text-white rounded-lg p-1">
              <BiExpand />
            </span>
          </button>
        );
      })}

      {selectedImageIndex !== null && (
        <ImageGalleryModal
          doShow
          images={images}
          initialIndex={selectedImageIndex}
          onClose={() => setSelectedImageIndex(null)}
        />
      )}
    </div>
  );
};

TourPhotos.propTypes = {
  images: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape()])).isRequired,
};

export default memo(TourPhotos);
